import { Tooltip } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

interface ErrorTooltipProps {
  title: string;
}

function ErrorTooltip({ title }: ErrorTooltipProps) {
  return (
    <Tooltip
      title={title}
      placement="bottom-start"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'error.main',
            color: 'common.white',
          },
        },
      }}
    >
      <WarningIcon sx={{ color: 'error.main', pr: '5px' }} />
    </Tooltip>
  );
}

export default ErrorTooltip;
